import { CommonErrorCode, FlowErrorCode } from '../helpers/ErrorCodes';
import { L10n } from '../L10n/L10n';
import { FlowContentType } from '../models/ContentTypes';
import { FlowBaseInfo } from '../models/FlowInfo';
import { IErrorItem } from '../models/MultipleItemResult';
import { Module } from '../Module';
import { IErrorDetail } from './ContentActionNotification';
import { ContentUrl } from './ContentUrl';
import { ServerService } from './ServerService';

export class FlowErrors {

  public static $inject = ['$translate', 'ContentUrl', 'ServerService'];

  constructor(
    private $translate: ng.translate.ITranslateService,
    private ContentUrl: ContentUrl,
    private ServerService: ServerService) { }

  public errorDetailsFor(flowErrorItem: IErrorItem<FlowBaseInfo>): IErrorDetail {
    return {
      itemName: flowErrorItem.item.name,
      itemUrl:
        flowErrorItem.error.code === CommonErrorCode.FlowNotFound
          ? null
          : this.ContentUrl.forItem(flowErrorItem.item, FlowContentType),
      errorMessage: this.errorMessageFor(flowErrorItem)
    };
  }

  public errorMessageFor(errorItem: IErrorItem<FlowBaseInfo>) {
    const flow = errorItem.item;
    switch (errorItem.error.code) {
      case CommonErrorCode.CallingUserInsufficientPermissions:
      case FlowErrorCode.FlowMoveInsufficientPermissionsOnDestinationProject:
        return this.$translate.instant('errorFlowInsufficientPermissions');
      case CommonErrorCode.FlowNotFound:
        return this.$translate.instant('errorFlowNotFound', { FLOW_NAME: L10n.elideIfLong(flow.name) });
      case FlowErrorCode.FlowWithSameNameInDestinationProject:
      case FlowErrorCode.FlowNameAlreadyExists:
        return this.$translate.instant('errorFlowNameAlreadyExists');
      case FlowErrorCode.FlowDestinationProjectNotFound:
        return this.$translate.instant('errorFlowDestinationProjectNotFound');
      case FlowErrorCode.FlowDescriptionTooLong:
        return this.$translate.instant('errorFlowDescriptionTooLong', { MAX_LENGTH: this.ServerService.maxDescriptionLength() });
      case CommonErrorCode.JobBulked:
        return this.$translate.instant('errorFlowJobBulked');
      default:
        return this.$translate.instant('errorUnknown');
    }
  }

}

Module.instance().service('FlowErrors', FlowErrors);
